<template>

    <div class="save-result divider-result">
        <v-card color="grey lighten-3">

        <v-form v-model="valid" ref="form" lazy-validation>
            <v-container fluid grid-list-md>
                <v-layout wrap row >
                    <v-flex xs12>
                        <div style="text-align: center; font-size: 22px; color:#00b7c6">چنانچه نیاز دارید ریز نتایج بدست آمده از آزمون خود را ببینید، لطفا فرم زیر را پر بفرمایید.</div>
                    </v-flex>
                    <v-flex sm3 xs6>
                        <v-text-field
                                box
                                label="نام و نام خانوادگی"
                                v-model="name"
                                :rules="requiredRules"
                                required
                        ></v-text-field>
                    </v-flex>
                    <v-flex sm3 xs6>
                        <v-text-field
                                box
                                label="سن"
                                v-model="age"
                                :rules="requiredRules"
                                required
                        ></v-text-field>
                    </v-flex>
                    <v-flex sm3 xs6>
                        <v-text-field
                                box
                                label="شماره تماس"
                                v-model="phone"
                                :rules="requiredRules"
                                required
                        ></v-text-field>
                    </v-flex>
                    <v-flex sm3 xs6>
                        <v-text-field
                                box
                                label="ایمیل"
                                v-model="email"
                                :rules="emailRules"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-btn
                                color="success"
                                @click="submit"
                                :disabled="!valid"
                        >ذخیره</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
        </v-card>
    </div>

</template>

<script>
    export default {
        props:['result','result_params'],
        data: () => ({
            valid: true,
            name: '',
            age: '',
            phone:'',
            requiredRules: [
                (v) => !!v || 'این فیلد اجباری است!',
            ],
            email: '',
            emailRules: [
                (v) => v.length > 0 ? /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'ایمیل وارد شده صحیح نمی باشد!' : true
            ],

        }),
        methods: {
            submit () {

                //console.log();
                //return false;
                if (this.$refs.form.validate()) {
                    let self = this;
                    self.axios.get(ApibaseUrl + "api/v1/save_result", {
                        params: {
                            name: this.name,
                            age: this.age,
                            phone: this.phone,
                            email: this.email,
                            result: this.result,
                            params: JSON.stringify(this.result_params),
                        }
                    }).then((response) => {
                        console.log(response);
                    })
                    self.$emit('showResult');
                }
            },
            clear () {
                this.$refs.form.reset()
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/HearingTest/SaveResult.vue